import accountRoutes from './routes'

/* @ngInject */
const accountRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(accountRoutes.index.path, {
      url: accountRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'accountCtrl',
      redirectTo: accountRoutes.home.path,
      data: {
        pageTitle: 'Mon compte',
      },
    })
    .state(accountRoutes.home.path, {
      url: accountRoutes.home.url,
      template: require('./templates/home.html'),
    })
    .state(accountRoutes.new.path, {
      url: accountRoutes.new.url,
      template: require('./templates/new.html'),
    })
    .state(accountRoutes.edit.path, {
      url: accountRoutes.edit.url,
      template: require('./templates/edit.html'),
    })
    .state(accountRoutes.consult.path, {
      url: accountRoutes.consult.url,
      template: require('./templates/consult.html'),
    })
}

export default accountRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/account/account.routes.js